<template lang="pug">
#page_content.ott.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row.justify-content-center: .col-sm-10
			template(v-if='$i18n.locale === "tw"')
				h2.title 網頁版註冊
				p.content
					| 網頁版註冊教學：
					a(href='https://www.ptsplus.tv/registration', target='_blank') https://www.ptsplus.tv/registration
				img.big(src='@/assets/images/faq/ott_1.png')
				h2.title 手機APP註冊
				p.content
					| 手機APP註冊教學：
					br
					| ★ 以下為Android系統註冊教學。ios系統暫無註冊功能，需至網頁版完成註冊，再用手機登入。
			template(v-else)
				ol
					li 
						| Go to
						|
						a(href='https://www.ptsplus.tv', target='_blank') https://www.ptsplus.tv
					li Click「註冊」to create your own personal account
					li Fill out application form
					li Log in to your registered email
					li Find the confirmation letter「公視+系統通知信」and click 「請點擊這裡啟用帳號」
					li 
						| Back to
						|
						a(href='https://www.ptsplus.tv', target='_blank') https://www.ptsplus.tv
					li Click「登入」enter your email and password
					li Now you can watch all the films online for free!
			.img_group
				img.small(
					v-for='item in [2, 3, 4, 5, 6]',
					v-bind:src='require(`@/assets/images/faq/ott_${item}.png`)',
					v-on:click='openModal($event)'
				)
	#gallery.modal.fade(
		tabindex='-1',
		aria-labelledby='gallery',
		aria-hidden='true'
	)
		.modal-dialog
			.modal-content
				.modal-header
					button.btn-close(
						type='button',
						data-bs-dismiss='modal',
						aria-label='Close'
					)
				.modal-body
					img(v-bind:src='imageUrl')
</template>

<script>
import Banner from '@/components/Banner.vue';
import { Modal } from 'bootstrap';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_3.jpg',
				title: this.$t('ott_title'),
			},
			modal: null,
			imageUrl: '',
		};
	},
	methods: {
		openModal: function (event) {
			this.imageUrl = event.target.currentSrc;
			this.modal.show();
		},
		initModal: function () {
			this.modal = new Modal(document.getElementById('gallery'));
		},
	},
	mounted() {
		this.initModal();
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('ott_title');
		},
	},
	components: {
		Banner,
	},
};
</script>
<style lang="stylus">
#page_content.ott
	.article
		padding: 6rem 0
	.article
		img
			display: flex
			&.big
				width: 60%
				margin: 0 auto 30px
				border-radius: 1rem
			&.small
				width: 25%
				margin: 0 10px 20px 0
				border-radius: 1rem
				cursor: pointer
		.img_group
			display: flex
			justify-content: center
			flex-wrap: wrap
		.note
			color: $color_light
			margin: 20px 0 60px 0
		.content
			text-align: left
			color: #fff
			line-height: 2
			margin-bottom: 30px
		a
			color: $color_yellow
	.modal-body
		img
			width: 100%
	@media screen and (max-width: $screen-sm-max)
		.article
			padding: 6rem 1rem
			img
				&.big
					width: 100%
				&.small
					width: 100%
</style>
